module.exports = __webpack_public_path__ + "img/3-longing-nl_v8e.13402de7.png";